/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Main_NavigationInputs */

const en_common_main_navigation = /** @type {(inputs: Common_Main_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const es_common_main_navigation = /** @type {(inputs: Common_Main_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegacion principal`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Common_Main_NavigationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_main_navigation = /** @type {((inputs?: Common_Main_NavigationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Main_NavigationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_main_navigation(inputs)
	return es_common_main_navigation(inputs)
});